import {CustomProductEffects} from "./custom-product.effect";
import {CustomProductsSearchEffects} from "./custom-product-search.effect";
import {CustomProductReviewsEffects} from "./custom-product-reviews.effect";
import {CustomProductReferencesEffects} from "./custom-product-references.effect";


export const effects: any[] = [
  CustomProductsSearchEffects,
  CustomProductEffects,
  CustomProductReviewsEffects,
  CustomProductReferencesEffects,
];

export * from './custom-product.effect';
export * from './custom-product-references.effect';
export * from './custom-product-reviews.effect';
export * from './custom-product-search.effect';
